// generated file with extracted css variables so we can use them in ie11

export default {
  fontFamily: '"InterVariable", sans-serif',
  fontFeatureSettings: '"cv02", "cv03", "cv04", "cv11"',
  surfaceA: "#ffffff",
  surfaceB: "#f9fafb",
  surfaceC: "#f3f4f6",
  surfaceD: "#e5e7eb",
  surfaceE: "#ffffff",
  surfaceF: "#ffffff",
  textColor: "#4b5563",
  textColorSecondary: "#6b7280",
  primaryColor: "#8b5cf6",
  primaryColorText: "#ffffff",
  surface0: "#ffffff",
  surface50: "#f9fafb",
  surface100: "#f3f4f6",
  surface200: "#e5e7eb",
  surface300: "#d1d5db",
  surface400: "#9ca3af",
  surface500: "#6b7280",
  surface600: "#4b5563",
  surface700: "#374151",
  surface800: "#1f2937",
  surface900: "#111827",
  gray50: "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray800: "#1f2937",
  gray900: "#111827",
  contentPadding: "1.25rem",
  inlineSpacing: "0.5rem",
  borderRadius: "6px",
  surfaceGround: "#f9fafb",
  surfaceSection: "#ffffff",
  surfaceCard: "#ffffff",
  surfaceOverlay: "#ffffff",
  surfaceBorder: "#dfe7ef",
  surfaceHover: "#f6f9fc",
  focusRing: "0 0 0 0.2rem #ddd6fe",
  maskbg: "rgba(0, 0, 0, 0.4)",
  highlightBg: "#f5f3ff",
  highlightTextColor: "#6d28d9",
  blue50: "#f5f9ff",
  blue100: "#d0e1fd",
  blue200: "#abc9fb",
  blue300: "#85b2f9",
  blue400: "#609af8",
  blue500: "#3b82f6",
  blue600: "#326fd1",
  blue700: "#295bac",
  blue800: "#204887",
  blue900: "#183462",
  green50: "#f4fcf7",
  green100: "#caf1d8",
  green200: "#a0e6ba",
  green300: "#76db9b",
  green400: "#4cd07d",
  green500: "#22c55e",
  green600: "#1da750",
  green700: "#188a42",
  green800: "#136c34",
  green900: "#0e4f26",
  yellow50: "#fefbf3",
  yellow100: "#faedc4",
  yellow200: "#f6de95",
  yellow300: "#f2d066",
  yellow400: "#eec137",
  yellow500: "#eab308",
  yellow600: "#c79807",
  yellow700: "#a47d06",
  yellow800: "#816204",
  yellow900: "#5e4803",
  cyan50: "#f3fbfd",
  cyan100: "#c3edf5",
  cyan200: "#94e0ed",
  cyan300: "#65d2e4",
  cyan400: "#35c4dc",
  cyan500: "#06b6d4",
  cyan600: "#059bb4",
  cyan700: "#047f94",
  cyan800: "#036475",
  cyan900: "#024955",
  pink50: "#fef6fa",
  pink100: "#fad3e7",
  pink200: "#f7b0d3",
  pink300: "#f38ec0",
  pink400: "#f06bac",
  pink500: "#ec4899",
  pink600: "#c93d82",
  pink700: "#a5326b",
  pink800: "#822854",
  pink900: "#5e1d3d",
  indigo50: "#f7f7fe",
  indigo100: "#dadafc",
  indigo200: "#bcbdf9",
  indigo300: "#9ea0f6",
  indigo400: "#8183f4",
  indigo500: "#6366f1",
  indigo600: "#5457cd",
  indigo700: "#4547a9",
  indigo800: "#363885",
  indigo900: "#282960",
  teal50: "#f3fbfb",
  teal100: "#c7eeea",
  teal200: "#9ae0d9",
  teal300: "#6dd3c8",
  teal400: "#41c5b7",
  teal500: "#14b8a6",
  teal600: "#119c8d",
  teal700: "#0e8174",
  teal800: "#0b655b",
  teal900: "#084a42",
  orange50: "#fff8f3",
  orange100: "#feddc7",
  orange200: "#fcc39b",
  orange300: "#fba86f",
  orange400: "#fa8e42",
  orange500: "#f97316",
  orange600: "#d46213",
  orange700: "#ae510f",
  orange800: "#893f0c",
  orange900: "#642e09",
  bluegray50: "#f7f8f9",
  bluegray100: "#dadee3",
  bluegray200: "#bcc3cd",
  bluegray300: "#9fa9b7",
  bluegray400: "#818ea1",
  bluegray500: "#64748b",
  bluegray600: "#556376",
  bluegray700: "#465161",
  bluegray800: "#37404c",
  bluegray900: "#282e38",
  purple50: "#fbf7ff",
  purple100: "#ead6fd",
  purple200: "#dab6fc",
  purple300: "#c996fa",
  purple400: "#b975f9",
  purple500: "#a855f7",
  purple600: "#8f48d2",
  purple700: "#763cad",
  purple800: "#5c2f88",
  purple900: "#432263",
  red50: "#fff5f5",
  red100: "#ffd0ce",
  red200: "#ffaca7",
  red300: "#ff8780",
  red400: "#ff6259",
  red500: "#ff3d32",
  red600: "#d9342b",
  red700: "#b32b23",
  red800: "#8c221c",
  red900: "#661814",
  primary50: "#f9f7ff",
  primary100: "#e3d8fd",
  primary200: "#cdb9fb",
  primary300: "#b79af9",
  primary400: "#a17bf8",
  primary500: "#8b5cf6",
  primary600: "#764ed1",
  primary700: "#6140ac",
  primary800: "#4c3387",
  primary900: "#382562",
  replaceableColors: {
    "replacedColor-139-92-246-1": {
      rgba: "rgba(139,92,246,1)",
      type: "primary",
      rgbKey: "139-92-246",
      hex: "#8b5cf6",
    },
    "replacedColor-109-40-217-1": {
      rgba: "rgba(109,40,217,1)",
      type: "active",
      rgbKey: "109-40-217",
      hex: "#6d28d9",
      transformationFromPrimary: {
        dst: 19.685218963665033,
        arg: 0,
        type: "darken",
      },
    },
    "replacedColor-139-92-246-0_24": {
      rgba: "rgba(139,92,246,0.24)",
      type: "primary",
      rgbKey: "139-92-246",
      hex: "#8b5cf6",
    },
    "replacedColor-124-58-237-1": {
      rgba: "rgba(124,58,237,1)",
      type: "hover",
      rgbKey: "124-58-237",
      hex: "#7c3aed",
      transformationFromPrimary: {
        dst: 16.539641504819123,
        arg: 0,
        type: "darken",
      },
    },
    "replacedColor-139-92-246-0_04": {
      rgba: "rgba(139,92,246,0.04)",
      type: "primary",
      rgbKey: "139-92-246",
      hex: "#8b5cf6",
    },
    "replacedColor-139-92-246-0_16": {
      rgba: "rgba(139,92,246,0.16)",
      type: "primary",
      rgbKey: "139-92-246",
      hex: "#8b5cf6",
    },
    "replacedColor-249-247-255-1": {
      rgba: "rgba(249,247,255,1)",
      type: "primaryGradient",
      rgbKey: "249-247-255",
      hex: "#f9f7ff",
      transformationFromPrimary: {
        dst: 0.41120827620607864,
        arg: 0.93,
        type: "brighten",
      },
    },
    "replacedColor-227-216-253-1": {
      rgba: "rgba(227,216,253,1)",
      type: "primaryGradient",
      rgbKey: "227-216-253",
      hex: "#e3d8fd",
      transformationFromPrimary: {
        dst: 1.0811127389146005,
        arg: 0.67,
        type: "brighten",
      },
    },
    "replacedColor-205-185-251-1": {
      rgba: "rgba(205,185,251,1)",
      type: "primaryGradient",
      rgbKey: "205-185-251",
      hex: "#cdb9fb",
      transformationFromPrimary: {
        dst: 1.6027457020075173,
        arg: 0.45,
        type: "brighten",
      },
    },
    "replacedColor-183-154-249-1": {
      rgba: "rgba(183,154,249,1)",
      type: "primaryGradient",
      rgbKey: "183-154-249",
      hex: "#b79af9",
      transformationFromPrimary: {
        dst: 1.6943735279319776,
        arg: 0.27,
        type: "brighten",
      },
    },
    "replacedColor-161-123-248-1": {
      rgba: "rgba(161,123,248,1)",
      type: "primaryGradient",
      rgbKey: "161-123-248",
      hex: "#a17bf8",
      transformationFromPrimary: {
        dst: 1.382400466376716,
        arg: 0.11,
        type: "brighten",
      },
    },
    "replacedColor-118-78-209-1": {
      rgba: "rgba(118,78,209,1)",
      type: "primaryGradient",
      rgbKey: "118-78-209",
      hex: "#764ed1",
      transformationFromPrimary: {
        dst: 0.17801085721683807,
        arg: 0.28,
        type: "darken",
      },
    },
    "replacedColor-97-64-172-1": {
      rgba: "rgba(97,64,172,1)",
      type: "primaryGradient",
      rgbKey: "97-64-172",
      hex: "#6140ac",
      transformationFromPrimary: {
        dst: 0.1952964774461261,
        arg: 0.51,
        type: "darken",
      },
    },
    "replacedColor-76-51-135-1": {
      rgba: "rgba(76,51,135,1)",
      type: "primaryGradient",
      rgbKey: "76-51-135",
      hex: "#4c3387",
      transformationFromPrimary: {
        dst: 0.3604118732439512,
        arg: 0.7000000000000001,
        type: "darken",
      },
    },
    "replacedColor-56-37-98-1": {
      rgba: "rgba(56,37,98,1)",
      type: "primaryGradient",
      rgbKey: "56-37-98",
      hex: "#382562",
      transformationFromPrimary: {
        dst: 0.40479444523717945,
        arg: 0.84,
        type: "darken",
      },
    },
  },
};
